import {GetCustomersRoutine} from '~modules/Companies/redux-routines';

export const initialState = {
  data: [],
  error: null,
  isLoading: false,
};

export const customersListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetCustomersRoutine.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GetCustomersRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    }
    case GetCustomersRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
